import {useLocation, useHistory} from 'react-router-dom';
import {DrillDownCategories, TaskCategories, ViewTypes} from '../../../../util/uiconstants';
import {labels} from '../../../../util/utils';
import {CountDetail, TemplateCardCounter} from '../TemplateCard/TemplateCardConfig';
import {useEffect} from 'react';
/**
 *
 * @param {array} labels Labels array for particular view
 * @param {array} counts Values for the corresponding labels
 * @returns {Object} object of TemplateCardCounter
 */
const GenaralCounter = (labels = [], counts = []) => {
	let counters = [];
	labels.forEach((label, index) => counters.push(new CountDetail(label, counts[index] ?? 0)));
	return counters;
};
/**
 *
 * @param {array} rowLabels Labels which needs to be display for row
 * @param {string} totalCountLabel Total count label for counter
 * @param {array} labels Labels array for particular view
 * @param {array} countArray Array of counter array for corresponding row
 * @param {boolean} displayTotal Flag for displaing total or not
 * @returns {MapEntry} Map entry for CounterSummary
 */
const getCounterComponents = (rowLabels = [], totalCountLabel, labels, countArray, displayTotal = true) => {
	if (rowLabels.length === 0) {
		return [
			new TemplateCardCounter({
				totalCountLabel: totalCountLabel,
				displayTotal,
				counterDetails: GenaralCounter(labels, countArray[0])
			})
		];
	}
	let counters = [];
	rowLabels.map((rowLabel, index) => {
		counters.push(
			new TemplateCardCounter({
				counterId: rowLabel,
				totalCountLabel: totalCountLabel,
				displayTotal,
				counterDetails: GenaralCounter(labels, countArray[index])
			})
		);
	});
	return counters;
};
/**
 *
 * @param {boolean} isEQR Flag for checking if engagement has EQR
 * @param {*} userSelected get selected user
 * @param {Map} counters Map of views and it's corresponding array of counter arrays
 * @returns {Map} Map of views and it's corresponding TemplateCardCounters
 */
const getCounterSummary = (isEQR = false, userSelected, counters = new Map()) => {
	const taskLabels = [labels.openLabel, labels.inProgress, labels.inreviewLabel, labels.completed];
	const documentLabels = isEQR
		? [labels.picSignoffInComplete, labels.eqrSignOffIncomplete]
		: [labels.picSignoffInComplete];
	// const assignmentsLabels = [labels.unassignedCapitalized, labels.openLabel, labels.inProgress, labels.closeLabel];
	const assignmentsLabels = [labels.currentAssigmentLabel, labels.UpcomingAssignments, labels.closed];
	const reviewNotesLabels = [labels.criticalLabel, labels.highLabel, labels.mediumLabel, labels.lowLabel];
	const collaborationLabels = [labels.drafts, labels.pendingLabel, labels.Received, labels.acceptedStatusLabel];
	const counterLabels = [
		{
			view: ViewTypes.tasks,
			labels: taskLabels,
			totalCountLabel: labels.total,
			rowLabels: [],
			displayTotal: true
		},
		{
			view: ViewTypes.documents,
			labels: documentLabels,
			totalCountLabel: labels.total,
			rowLabels: [],
			displayTotal: false
		},
		{
			view: ViewTypes.assignments,
			labels: assignmentsLabels,
			totalCountLabel: labels.total,
			rowLabels: [],
			displayTotal: true
		},
		{
			view: ViewTypes.reviewnotes,
			labels: reviewNotesLabels,
			totalCountLabel: labels.total,
			rowLabels:
				userSelected?.label === labels.allLabel
					? [labels.open, labels.cleared]
					: [labels.assignedToOpen, labels.authoredByCleared],
			displayTotal: true
		},
		{
			view: ViewTypes.collaboration,
			labels: collaborationLabels,
			totalCountLabel: labels.total,
			rowLabels: [],
			displayTotal: true
		}
	];
	let counterSummary = new Map();
	counterLabels.map((counter, index) =>
		counterSummary.set(
			counter.view,
			getCounterComponents(
				counter.rowLabels,
				counter.totalCountLabel,
				counter.labels,
				counters.get(counter.view) ?? [],
				counter.displayTotal
			)
		)
	);
	return counterSummary;
};
export {getCounterSummary};

// status count is used to store counts of different views.
export const getNameOfStatusCount = (view) => {
	switch (view) {
		case ViewTypes.tasks:
			return 'taskStatusCounts';
		case ViewTypes.assignments:
			return 'assignmentStatusCount';
		case ViewTypes.collaboration:
			return 'clientRequestCounts';
		case ViewTypes.reviewnotes:
			return 'reviewNoteCounts';
		case ViewTypes.documents:
			return 'documentCounts';
	}
};

// to map api view with view on UI
export const getAPIViewFromViewType = (viewType) => {
	switch (viewType) {
		case ViewTypes.tasks:
			return 'tasks';
		case ViewTypes.assignments:
			return 'assignments';
		case ViewTypes.documents:
			return 'documents';
		case ViewTypes.collaboration:
			return 'clientRequests';
		case ViewTypes.reviewnotes:
			return 'reviewNotes';
	}
};

// Drill down categories are string so this returns the numeric counter parts of them.
export const getTaskCategoryFromDrillDownCategory = (drillDownCategory) => {
	switch (drillDownCategory) {
		case DrillDownCategories.scopestrategy:
			return TaskCategories.ScopeStrategy;
		case DrillDownCategories.execution:
			return TaskCategories.ExecutionGeneral;
		case DrillDownCategories.conclusion:
			return TaskCategories.Conclusion;
		case DrillDownCategories.account:
			return TaskCategories.ExecutionAccounts;
		case DrillDownCategories.scot:
			return TaskCategories.ExecutionSCOTs;
		case DrillDownCategories.risk:
			return TaskCategories.Risks;
		case DrillDownCategories.itprocess:
			return TaskCategories.ExecutionITSOs;
	}
};

export const useIsReloadRequired = (
	resetState = () => {
		console.log('Missing resetState function');
	}
) => {
	const location = useLocation();
	const history = useHistory();
	useEffect(() => {
		if (location.state?.reloadTaskCounts == true) {
			resetState();
			history.replace({
				...location,
				state: {
					...location.state,
					reloadTaskCounts: false
				}
			});
		}
	}, [location]);
};

/*
	getCounterSummary function for two dimensional array
	i/p: array of counters
	returns: Map of counterSummary of particular card
*/

// const getCounterSummary = (counters = []) => {
// 	const taskLabels = [labels.openLabel, labels.inProgress, labels.inreviewLabel, labels.CompleteLabel];
// 	const documentLabels = [labels.picSignoffInComplete, labels.eqrSignOffIncomplete];
// 	const assignmentsLabels = [labels.unassignedCapitalized, labels.openLabel, labels.inProgress, labels.closeLabel];
// 	const reviewNotesLabels = [labels.criticalLabel, labels.highLabel, labels.mediumLabel, labels.lowLabel];
// 	const collaborationLabels = [
// 		labels.unsentDraftCapitalized,
// 		labels.pendingLabel,
// 		labels.Received,
// 		labels.acceptedStatusLabel
// 	];
// 	const counterLabels = [
// 		{
// 			view: ViewTypes.tasks,
// 			labels: taskLabels,
// 			totalCountLabel: labels.totalTasksLabel,
// 			rowLabels: [],
// 			displayTotal: true
// 		},
// 		{
// 			view: ViewTypes.documents,
// 			labels: documentLabels,
// 			totalCountLabel: labels.total,
// 			rowLabels: [],
// 			displayTotal: false
// 		},
// 		{
// 			view: ViewTypes.assignments,
// 			labels: assignmentsLabels,
// 			totalCountLabel: currentResource.reportTaskAssignments.totalAssignment,
// 			rowLabels: [],
// 			displayTotal: true
// 		},
// 		{
// 			view: ViewTypes.reviewNotes,
// 			labels: reviewNotesLabels,
// 			totalCountLabel: labels.total,
// 			rowLabels: [labels.open, labels.cleared],
// 			displayTotal: true
// 		},
// 		{
// 			view: ViewTypes.collaboration,
// 			labels: collaborationLabels,
// 			totalCountLabel: labels.total,
// 			rowLabels: [],
// 			displayTotal: true
// 		}
// 	];
// 	let counterSummary = new Map();
// 	counterLabels.map((counter, index) =>
// 		counterSummary.set(
// 			counter.view,
// 			getCounterComponents(
// 				counter.rowLabels,
// 				counter.totalCountLabel,
// 				counter.labels,
// 				counters[index] ?? [],
// 				counter.displayTotal
// 			)
// 		)
// 	);
// 	return counterSummary;
// };

// export {getCounterSummary};

/*
	getCounterSummary function for one dimensional array
	i/p: array of counters
	returns: Map of counterSummary of particular card
*/

// const getCounterSummary = (counters = []) => {
// 	const taskLabels = [labels.openLabel, labels.inProgress, labels.inreviewLabel, labels.CompleteLabel];
// 	const documentLabels = [labels.picSignoffInComplete, labels.eqrSignOffIncomplete];
// 	const assignmentsLabels = [labels.unassignedCapitalized, labels.openLabel, labels.inProgress, labels.closeLabel];
// 	const reviewNotesLabels = [labels.criticalLabel, labels.highLabel, labels.mediumLabel, labels.lowLabel];
// 	const collaborationLabels = [
// 		labels.unsentDraftCapitalized,
// 		labels.pendingLabel,
// 		labels.Received,
// 		labels.acceptedStatusLabel
// 	];
// 	const counterLabels = [
// 		{
// 			view: ViewTypes.tasks,
// 			labels: taskLabels,
// 			totalCountLabel: labels.totalTasksLabel
// 		},
// 		{
// 			view: ViewTypes.documents,
// 			labels: documentLabels,
// 			totalCountLabel: labels.total
// 		},
// 		{
// 			view: ViewTypes.assignments,
// 			labels: assignmentsLabels,
// 			totalCountLabel: currentResource.reportTaskAssignments.totalAssignment
// 		},
// 		{
// 			view: ViewTypes.reviewNotes,
// 			labels: reviewNotesLabels,
// 			totalCountLabel: labels.total
// 		},
// 		{
// 			view: ViewTypes.collaboration,
// 			labels: collaborationLabels,
// 			totalCountLabel: labels.total
// 		}
// 	];
// 	let counterSummary = new Map();
// 	counterLabels.map((counter, index) =>
// 		counterSummary.set(
// 			counter.view,
// 			new TemplateCardCounter({
// 				counterId: counter.view,
// 				totalCountLabel: counter.totalCountLabel,
// 				counterDetails: GenaralCounter(counter.labels, counters[index])
// 			})
// 		)
// 	);
// 	return counterSummary;
// };

// export {getCounterSummary};

/*
	getTaskCounterSummary function for one dimensional array
	i/p: array of counter
	returns: Map entry of counterSummary of particular card
*/

// const getTaskCounterSummary = (countArray = []) => {
// 	const taskLabels = [labels.openLabel, labels.inProgress, labels.inreviewLabel, labels.CompleteLabel];
// 	return [
// 		ViewTypes.tasks,
// 		new TemplateCardCounter({
// 			counterId: ViewTypes.tasks,
// 			totalCountLabel: labels.totalTasksLabel,
// 			counterTitle: labels.taskStatusLabel,
// 			counterDetails: GenaralCounter(taskLabels, countArray)
// 		})
// 	];
// };

/*
	getDocumentCounterSummary function for one dimensional array
	i/p: array of counter
	returns: Map entry of counterSummary of particular card
*/

// const getDocumentCounterSummary = (countArray = []) => {
// 	const documentLabels = [labels.picSignoffInComplete, labels.eqrSignOffIncomplete];
// 	return [
// 		ViewTypes.documents,
// 		new TemplateCardCounter({
// 			counterId: ViewTypes.documents,
// 			counterDetails: GenaralCounter(documentLabels, countArray)
// 		})
// 	];
// };

/*
	getAssignmentCounterSummary function for one dimensional array
	i/p: array of counter
	returns: Map entry of counterSummary of particular card
*/

// const getAssignmentCounterSummary = (countArray = []) => {
// 	const assignmentsLabels = [labels.unassignedCapitalized, labels.openLabel, labels.inProgress, labels.closeLabel];
// 	return [
// 		ViewTypes.assignments,
// 		new TemplateCardCounter({
// 			counterId: ViewTypes.assignments,
// 			totalCountLabel: currentResource.reportTaskAssignments.totalAssignment,
// 			counterDetails: GenaralCounter(assignmentsLabels, countArray)
// 		})
// 	];
// };

/*
	getReviewNotesCounterSummary function for one dimensional array
	i/p: array of counter
	returns: Map entry of counterSummary of particular card
*/

// const getReviewNotesCounterSummary = (countArray = []) => {
// 	const reviewNotesLabels = [labels.criticalLabel, labels.highLabel, labels.mediumLabel, labels.lowLabel];
// 	return [
// 		ViewTypes.reviewNotes,
// 		new TemplateCardCounter({
// 			counterId: ViewTypes.reviewNotes,
// 			counterDetails: GenaralCounter(reviewNotesLabels, countArray)
// 		})
// 	];
// };

/*
	getCollaborationCounterSummary function for one dimensional array
	i/p: array of counter
	returns: Map entry of counterSummary of particular card
*/

// const getCollaborationCounterSummary = (countArray = []) => {
// 	const collaborationLabels = [
// 		labels.unsentDraftCapitalized,
// 		labels.pendingLabel,
// 		labels.Received,
// 		labels.acceptedStatusLabel
// 	];
// 	return [
// 		ViewTypes.collaboration,
// 		new TemplateCardCounter({
// 			counterId: ViewTypes.collaboration,
// 			counterDetails: GenaralCounter(collaborationLabels, countArray)
// 		})
// 	];
// };

/*
	getCounterSummary function for one dimensional array
	i/p: array of counters
	returns: Map of counterSummary of particular card
*/

// const getCounterSummary = (counters = []) => {
// 	return new Map([
// 		getTaskCounterSummary([...counters[0]]),
// 		getDocumentCounterSummary([...counters[1]]),
// 		getAssignmentCounterSummary([...counters[2]]),
// 		getReviewNotesCounterSummary([...counters[3]]),
// 		getCollaborationCounterSummary([...counters[4]])
// 	]);
// };

// export {getCounterSummary};
